module.exports = __webpack_public_path__ + "assets/Group.c310bcefb4ac5f95680e9492b8315120.png";